export const generateBreadcrumbs = (FullURL: string) => {
    const siteURL = process.env.NEXT_PUBLIC_FRONTEND_URL || ''; 

    // const pathArray = FullURL.split("/").filter(Boolean);

    const pathArray = FullURL.split('/').filter((segment) => segment !== '');
    const mappedPathArray = pathArray.map((segment) => {
      if (segment === 'services') return 'what-we-do';
      if (segment === 'web') return 'web-development';
      if (segment === 'mobile') return 'mobile-app-development';
      return segment;
    });

    const breadcrumbs = [
        {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: siteURL + "/",
        },
        ...mappedPathArray.map((segment, index) => ({
            "@type": "ListItem",
            position: index + 2,
            name: segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' '),
            item: `${siteURL}/${mappedPathArray.slice(0, index + 1).join("/")}`,
        })),
    ];

    return JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "name": "Breadcrumb",
        itemListElement: breadcrumbs,
    });
};
